import React from "react";
import TestsPageTemplate from "../components/TestsPageTemplate";
import {TEST_TYPES} from "../../../../shared/types/testTypes";

const TestsNumericLiteracy = () => {

    return (
        <TestsPageTemplate
            config={TEST_TYPES.numericLiteracy}
        />
    );
};

export default TestsNumericLiteracy;
